import { useNavigate } from 'react-router-dom';
import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import { showErrorNotification, showSuccessNotification } from '../../components/notifications';
import { useLoadingOverlay } from '../../components/LoadingOverlayContext';

export const useLogin = () => {
    const navigate = useNavigate();
    const { setLoading } = useLoadingOverlay();

    const getApiKeyMutation = useMutation({
        mutationFn: async (pwaKey: string) => {
            const response = await axios.post(`${process.env.REACT_APP_STUDIO_API_URL}/key-auth`, { pwaKey });
            return response.data.key;
        },
        onSuccess: (apiKey) => {
            //console.log('Api key:', apiKey);
            localStorage.setItem('apiKey', apiKey);
        }
    });

    const getUserDataMutation = useMutation({
        mutationFn: async (apiKey: string) => {
            const response = await axios.get(`${process.env.REACT_APP_STUDIO_API_URL}/pwa/user-test`, {
                headers: {
                    Authorization: `Bearer ${apiKey}`
                }
            });
            return response.data;
        },
        onSuccess: (data) => {
            //console.log('User data:', data);
            localStorage.setItem('isLogged', 'true');
            showSuccessNotification('Pomyślnie zalogowano.', 'Sukces');
            navigate('/dashboard');
        }
    });

    const login = async (pwaKey: string) => {
        try {
            setLoading(true)
            const apiKey = await getApiKeyMutation.mutateAsync(pwaKey);
            await getUserDataMutation.mutateAsync(apiKey);
        } catch (error) {
            showErrorNotification('Nie udało się zalogować.', 'Błąd');
            console.error('Login failed:', error);
        } finally {
            setLoading(false)
        }
    }
    
    return { 
        login, 
        isLoading: getApiKeyMutation.isPending || getUserDataMutation.isPending 
    };
}